export const LOCAL_STORAGE_CONVERSATION = 'CONVERSATION';
export const VIDEO_WITH_NESTED_IMAGE = 'video-with-nested-image';
